// src/app/core/loaders/multi-translate.loader.ts
import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

export class MultiTranslateLoader implements TranslateLoader {
    constructor(
        private http: HttpClient,
        private modules: string[]
    ) {}

    getTranslation(lang: string): Observable<any> {
        const requests = this.modules.map(module =>
            this.http.get<any>(`/assets/i18n/${module}/${lang}.json`)
        );

        return forkJoin(requests).pipe(
            map(responses => Object.assign({}, ...responses))
        );
    }
}
